//ConsoleService.portalServerUrl

var app = angular.module('ThingItMobile', [
    'ngRoute',
    'mobile-angular-ui',
    "mobile-angular-ui.gestures",
    "ui.checkbox",
    'ThingItMobile.ConsoleService',
    "ThingItMobile.PluginDirectives",
    'ThingItMobile.Main'
]);

app.config(function ($routeProvider) {
    $routeProvider.when('/', {templateUrl: 'connectingPage.html', reloadOnSearch: false});
    $routeProvider.when('/login', {templateUrl: 'loginPage.html', reloadOnSearch: false});
    $routeProvider.when('/termsAndConditions', {templateUrl: 'termsAndConditionsPage.html', reloadOnSearch: false});
    $routeProvider.when('/meshes', {templateUrl: 'meshesPage.html', reloadOnSearch: false});
    $routeProvider.when('/communication', {templateUrl: 'communicationPage.html', reloadOnSearch: false});
    $routeProvider.when('/wiki', {templateUrl: 'wikiPage.html', reloadOnSearch: false});
    $routeProvider.when('/page', {templateUrl: 'pagePage.html', reloadOnSearch: false});
    $routeProvider.when('/channel', {templateUrl: 'channelPage.html', reloadOnSearch: false});
    $routeProvider.when('/toDo', {templateUrl: 'toDoPage.html', reloadOnSearch: false});
    $routeProvider.when('/task', {templateUrl: 'taskPage.html', reloadOnSearch: false});
    $routeProvider.when('/process', {templateUrl: 'processPage.html', reloadOnSearch: false});
    $routeProvider.when('/mesh', {templateUrl: 'meshPage.html', reloadOnSearch: false});
    $routeProvider.when('/node', {templateUrl: 'nodePage.html', reloadOnSearch: false});
    $routeProvider.when('/group', {templateUrl: 'groupPage.html', reloadOnSearch: false});
    $routeProvider.when('/device', {templateUrl: 'devicePage.html', reloadOnSearch: false});
    $routeProvider.when('/actor', {templateUrl: 'actorPage.html', reloadOnSearch: false});
    $routeProvider.when('/sensor', {templateUrl: 'sensorPage.html', reloadOnSearch: false});
    $routeProvider.when('/monitoring', {templateUrl: 'monitoringPage.html', reloadOnSearch: false});
    $routeProvider.when('/userManagement', {templateUrl: 'userManagementPage.html', reloadOnSearch: false});
    $routeProvider.when('/user', {templateUrl: 'userPage.html', reloadOnSearch: false});
    $routeProvider.when('/settings', {templateUrl: 'settingsPage.html', reloadOnSearch: false});
    $routeProvider.when('/nodeConfiguration', {templateUrl: 'nodeConfigurationPage.html', reloadOnSearch: false});
    $routeProvider.when('/deviceConfiguration', {templateUrl: 'deviceConfigurationPage.html', reloadOnSearch: false});
    $routeProvider.when('/actorConfiguration', {templateUrl: 'actorConfigurationPage.html', reloadOnSearch: false});
    $routeProvider.when('/sensorConfiguration', {templateUrl: 'sensorConfigurationPage.html', reloadOnSearch: false});
    $routeProvider.when('/groupConfiguration', {templateUrl: 'groupConfigurationPage.html', reloadOnSearch: false});
    $routeProvider.when('/serviceConfiguration', {templateUrl: 'serviceConfigurationPage.html', reloadOnSearch: false});
    $routeProvider.when('/eventProcessorConfiguration', {
        templateUrl: 'eventProcessorConfigurationPage.html',
        reloadOnSearch: false
    });
    $routeProvider.when('/storyboardConfiguration', {
        templateUrl: 'storyboardConfigurationPage.html',
        reloadOnSearch: false
    });
    $routeProvider.when('/storyboardStepConfiguration', {
        templateUrl: 'storyboardStepConfigurationPage.html',
        reloadOnSearch: false
    });
    $routeProvider.when('/jobConfiguration', {templateUrl: 'jobConfigurationPage.html', reloadOnSearch: false});
    $routeProvider.when('/notifications', {templateUrl: 'notificationsPage.html', reloadOnSearch: false});
});
app.config(function ($sceDelegateProvider) {
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from outer templates domain.
        'http://**',
        // Allow loading from outer templates domain.
        'https://**'
    ]);
});

